import { Resource } from 'constants/resources';

import { useEffect, useRef } from 'react';

import { usePermissions } from 'hooks/usePermissions';
import {
  BulkDeleteButton,
  DatagridProps as RaDatagridProps,
  useListContext,
  useRemoveFromStore,
} from 'react-admin';
import { DatagridNoResults } from 'shared/react-admin/Datagrids/DatagridNoResults/DatagridNoResults';
import {
  ResizableColumns,
  useColumnResize,
} from 'shared/react-admin/Datagrids/hooks/useColumnResize';
import { Permission } from 'types/embedded/permission';

import { StyledDatagrid } from './Datagrid.styled';

export type DatagridProps = RaDatagridProps & {
  resizableColumns?: ResizableColumns;
};

const getDefaultRowSx = () => ({ backgroundColor: 'white' });

export const Datagrid: React.FC<DatagridProps> = ({
  rowSx,
  empty = <DatagridNoResults />,
  rowClick = false,
  resizableColumns,
  ...props
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { resource } = useListContext();
  const { hasResourcePermissions } = usePermissions();

  const remove = useRemoveFromStore();
  useColumnResize(containerRef, resizableColumns);

  useEffect(() => {
    return () => {
      remove(`${resource}.selectedIds`);
    };
  }, []);

  return (
    <div ref={containerRef}>
      <StyledDatagrid
        bulkActionButtons={
          hasResourcePermissions(resource as Resource, [Permission.Full, Permission.Delete]) && (
            <BulkDeleteButton />
          )
        }
        empty={empty}
        {...props}
        rowClick={rowClick}
        rowSx={rowSx || getDefaultRowSx}
      />
    </div>
  );
};
